// libs
import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

// mixins
import { HIDE_SCROLLBARS } from 'shared/styles/base';

import IOElement from 'shared/components/IOElement';
const ScrollAnimation = (x: number | string) => keyframes`
0% {
  transform: translateX(0%);
}
45%, 56% {
  transform: translateX(-${x}px);
}
100% {
  transform: translateX(0);
}
`;

const heightAnimation = keyframes`
    from{
      max-height: 0px;
    }
    to{
      max-height: 500px;
     
    }
`;

export const SizeChartContainer = styled.div`
  border-radius: 2px;
  position: relative;
  animation: ${heightAnimation} 0.5s linear;
  overflow: hidden;
  ${({ theme }) => `
    border: 1px solid ${theme.colors.textDecorative};
    background: ${theme.colors.surface};
    margin-top: ${theme.spacing.spacing80};
  `};
  max-width: 100vw;
`;

export const SizeTable = styled.table<{ lasColumnPosition: number; singleColumn: boolean }>`
  border-collapse: collapse;
  width: auto;
  position: relative;
  z-index: 1;
  ${({ singleColumn, theme }) =>
    singleColumn &&
    `
    .data,.heading{
      &:nth-child(odd) {
        background-color: ${theme.colors.surface};
      }
    }
  `};
  &.show-animation {
    animation: ${({ lasColumnPosition }) => ScrollAnimation(lasColumnPosition)} 1450ms linear;
    scroll-snap-stop: always;
    animation-delay: 650ms;
  }
`;

export const SizeTableHeading = styled.th<{ isSetWidth: boolean }>`
  text-align: left;
  text-transform: uppercase;
  ${({ isSetWidth }) => (isSetWidth ? `width: 100%;` : `width: auto;`)}

  vertical-align: top;

  ${({ theme }) => theme.typography.labelMedium};
  ${({ theme }) => `
    color: ${theme.colors.textPrimary};
    padding: ${theme.spacing.spacing60}  ${theme.spacing.spacing80} 0px;
  `};

  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.surface10};
  }
`;

export const SizeTableData = styled.td`
  ${({ theme }) => theme.typography.bodyMedium};
  white-space: nowrap;
  ${({ theme }) => `
    color: ${theme.colors.textPrimary};
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80}  ${theme.spacing.spacing60};
  `};
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.surface10};
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodySmall};
  flex: 0.65;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const BoxTitleContainer = styled.div`
  position: relative;
  display: flex;
  ${({ theme }) => `
    padding: ${theme.spacing.spacing60} ${theme.spacing.spacing20} ${theme.spacing.spacing60} ${theme.spacing.spacing80};
    border-bottom: 1px solid ${theme.colors.textDecorative};
  `};
`;

export const BoxTableContainer = styled.div`
  overflow-x: scroll;
  ${HIDE_SCROLLBARS};
`;

export const BgImage = styled.div`
  position: absolute;
  right: 0;
  opacity: 0.64;
`;

export const HeadingChild = styled.div`
  max-width: 132px;
  width: max-content;
`;

export const StyledIOElement = styled(IOElement)`
&.bottomsheet-wrap {
  width: 100%;
}
`;